module.exports = __webpack_public_path__ + "img/huawei3.8ea29e97.png";